module.exports = __webpack_public_path__ + "static/img/3.354e3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/3.png
// module id = wtHY
// module chunks = 0